import { ProcessPatientRequestsResponse } from '../../models/paymentSubmissions';
import client from '../httpclient';

const processPatientRequests = (
  patientId: string,
  currency: string
): Promise<ProcessPatientRequestsResponse> =>
  client.post(`/re/v1/patient/${patientId}/reimbursement-request/process`, {
    currency,
  });

export default processPatientRequests;
